import { getUrlParams } from 'pages_creditScore/auth/utils';
import { CommonFetcherResponse } from '../type';

const creditScoreAuthAPI = () => {
  let baseURL: URL | null = null;
  let token: string | null = null;
  const inititateAPI = (APIURL: string) => {
    baseURL = new URL(APIURL);
  };
  const setToken = (accessToken: string) => {
    token = accessToken;
  };
  const removeToken = () => {
    token = null;
  };
  const getToken = () => {
    return token;
  };
  const isAPIInitialized = () => {
    if (token === null && baseURL === null) {
      return false;
    }
    return true;
  };
  const getBaseURL = () => {
    return baseURL;
  };

  const internalFetcher = async (
    url: string,
    payload: any
  ): Promise<CommonFetcherResponse> => {
    if (!isAPIInitialized()) {
      return {
        status: 'failure',
        data: 'Invalid token or API not initialized'
      };
    }
    try {
      let response = await fetch(new URL(url, baseURL as URL).href, {
        method: 'POST',
        ...payload,
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Cibil: getUrlParams()?.bureau === 'equifax' ? 'E' : 'T'
        })
      });
      if (String(response.status) === '200') {
        let data = await response.json();
        return {
          status: String(data.status) === '0' ? 'success' : 'failure',
          data: data
        };
      } else if (String(response.status) === '401') {
        let data = await response.json();
        //@ts-ignore
        if (typeof window.__logout === 'function') {
          //@ts-ignore
          window.__logout();
        }
        return {
          status: 'failure',
          data: data
        };
      } else {
        return {
          status: 'failure',
          data: ''
        };
      }
    } catch (e) {
      return {
        status: 'failure',
        data: e
      };
    }
  };

  const internalInitiateFatcher = async (
    url: string,
    payload: any
  ): Promise<CommonFetcherResponse> => {
    if (!isAPIInitialized()) {
      return {
        status: 'failure',
        data: 'Invalid token or API not initialized'
      };
    }
    try {
      let response = await fetch(new URL(url, baseURL as URL).href, {
        method: 'POST',
        ...payload,
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      });
      if (String(response.status) === '200') {
        let data = await response.json();
        return {
          status: String(data.status) === '0' ? 'success' : 'failure',
          data: data
        };
      } else if (String(response.status) === '401') {
        //@ts-ignore
        if (typeof window.__logout === 'function') {
          //@ts-ignore
          window.__logout();
        }
        return {
          status: 'failure',
          data: ''
        };
      } else {
        return {
          status: 'failure',
          data: ''
        };
      }
    } catch (e) {
      return {
        status: 'failure',
        data: e
      };
    }
  };
  return {
    inititateAPI,
    internalFetcher,
    getBaseURL,
    getToken,
    removeToken,
    setToken,
    internalInitiateFatcher
  };
};

export const CRSAuthSDK = creditScoreAuthAPI();
